import { render, staticRenderFns } from "./ModalUploadDocument.vue?vue&type=template&id=3b5add00&scoped=true"
import script from "./ModalUploadDocument.vue?vue&type=script&lang=js"
export * from "./ModalUploadDocument.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadDocument.vue?vue&type=style&index=0&id=3b5add00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5add00",
  null
  
)

export default component.exports